// @ts-expect-error FIXME: REPAIR UPGRADE TO NEWER VERSION
import { AnimatePresence } from 'framer-motion';
import { useRef } from 'react';
import { createPortal } from 'react-dom';

import { NotificationsProps } from './Notifications';
import { NotificationsList } from './NotificationsList/NotificationsList';

import { IconButton } from '@speeki/icons';
import { useOnClickOutside } from '@speeki/react-hooks';

import {
    CloseIconWrapper,
    MobileNotificationsWrapper,
} from './Notifications.styled';

export const MdNotifications = ({ isOpen, onClose }: NotificationsProps) => {
    const selectRef = useRef(null);
    useOnClickOutside(selectRef, onClose);

    return createPortal(
        <AnimatePresence>
            {isOpen && (
                <MobileNotificationsWrapper
                    animate={{
                        x: 40,
                    }}
                    exit={{
                        x: '100vw',
                    }}
                    initial={{
                        x: '100vw',
                    }}
                    ref={selectRef}
                    transition={{ type: 'tween' }}
                >
                    <CloseIconWrapper>
                        <IconButton
                            iconProps={{
                                icon: 'SvgCloseBig24',
                                size: 24,
                            }}
                            onClick={onClose}
                            testId="DP6piIG"
                        />
                    </CloseIconWrapper>
                    <NotificationsList onClose={onClose} />
                </MobileNotificationsWrapper>
            )}
        </AnimatePresence>,

        document.getElementById('notifications')!,
    );
};
